import React from 'react';
import './gallery.css';

import ArrowForwardIosIcon from '@material-ui/icons/ArrowForwardIos';

import img1 from '../assests/img1.jpg';
import img2 from '../assests/img2.jpg';
import img3 from '../assests/img3.jpg';
import img4 from '../assests/img4.jpg';
import img5 from '../assests/img5.jpg';
import img6 from '../assests/img6.jpg';
import img7 from '../assests/img7.jpg';
import img8 from '../assests/img8.jpg';
import img9 from '../assests/img9.jpg';
import img10 from '../assests/img10.jpg';
import img11 from '../assests/img11.jpg';
import img12 from '../assests/img12.jpg';
import img13 from '../assests/img13.jpg';
import img14 from '../assests/img14.jpg';
import img15 from '../assests/img15.jpg';


function Gallery() {
  return (
    <div className='gallerysec'>
        <div className="coursessec">
            <div className="introabout">
                <p className="abouttitle">Gallery</p>
                <p className="subabout">Home <span><ArrowForwardIosIcon className='spanicon' /><ArrowForwardIosIcon className='spanicon1' /></span> Gallery</p>
            </div>
        </div>
        <div className="gallerysecimg">
            <img src={img1} width="250" height="200" alt="" />
            <img src={img2} width="250" height="200" alt="" />
            <img src={img3} width="250" height="200" alt="" />
        </div>
        <div className="gallerysecimg">
            <img src={img4} width="250" height="200" alt="" />
            <img src={img5} width="250" height="200" alt="" />
            <img src={img6} width="250" height="200" alt="" />
        </div>
        <div className="gallerysecimg">
            <img src={img7} width="250" height="200" alt="" />
            <img src={img8} width="250" height="200" alt="" />
            <img src={img9} width="250" height="200" alt="" />
        </div>
        <div className="gallerysecimg">
            <img src={img10} width="250" height="200" alt="" />
            <img src={img11} width="250" height="200" alt="" />
            <img src={img12} width="250" height="200" alt="" />
        </div>
        <div className="gallerysecimg">
            <img src={img13} width="250" height="200" alt="" />
            <img src={img14} width="250" height="200" alt="" />
            <img src={img15} width="250" height="200" alt="" />
        </div>
        
        
        
        </div>
  )
}

export default Gallery